module.exports = __webpack_public_path__ + "img/node.f6b59711.png";